module.exports = __webpack_public_path__ + "static/media/Logo.f15ea2b7.png";